import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import Link from '@/src/shared/components/Link';
import Table from '@/src/shared/components/Table';
import { colors } from '@/styles';
import request from '@/utils/axios';

const style = {
  name: css`
    color: ${colors.secondaryBlue};
    font-weight: bolder;
  `,
  sorterText: css`
    font-weight: bolder;
    margin-bottom: 0px;
  `,
};

const StateSort = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchData = async type => {
    const result = await request({
      url: `profile/staffprofiles?type=${type}`,
    });
    const {
      data: { Profiles },
    } = result;
    setData(Profiles);
    setLoading(false);
  };

  useEffect(() => {
    fetchData('state');
  }, []);

  const columns = [
    {
      title: 'State',
      dataIndex: 'State',
      key: 'State',
      render: text => {
        return <p css={style.sorterText}>{text}</p>;
      },
      width: '150px',
    },
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
      render: (text, record) => {
        return (
          <Link anchor css={style.name} href={`mailto:${record.EmailAddress}`}>
            {text}
          </Link>
        );
      },
      width: '250px',
    },
    {
      title: 'Phone',
      dataIndex: 'Phone',
      key: 'Phone',
      render: text => {
        return (
          <Link anchor href={`tel:${text}`}>
            {text}
          </Link>
        );
      },
      width: '180px',
    },
  ];
  return (
    <Table
      columns={columns}
      dataSource={data}
      rowKey={record => `${record.PersonId}-${record.State}`}
      loading={loading}
      showHeader={false}
      pagination={false}
      scroll={{ x: 580 }}
      css={css`
        .ant-table-row-cell-break-word {
          white-space: normal !important;
        }
      `}
    />
  );
};

StateSort.propTypes = {};

export default StateSort;
